import { useRoutes } from "react-router-dom";

import { PRIVATE_ROUTES, PUBLIC_ROUTES } from "./pages";

function Router() {
  const routes = useRoutes(
    // PUBLIC_ROUTES
    localStorage.getItem("access-token") ? PRIVATE_ROUTES : PUBLIC_ROUTES
  );
  return routes;
}

export default Router;
